<template>
  <main>
    <SectionHero :variant="hero.variant">
      <OrganismHero :hero="hero" />
      <template #footerShort>
        <div class="flex flex-col flex-1 gap-y-3 md:flex-row gap-x-[10px] justify-between">
          <div class="flex flex-col flex-1 gap-y-3 md:flex-row gap-x-[10px] md:items-end -md:order-2">
            <div>
              <!-- Use index based on URL slug -->
              <AtomButtonDropdown
                :items="clubDropdownItems"
                :initial-index="selectedClubIndex"
                @select="onClubSelect"
              />
            </div>
          </div>
          <AtomButton class="self-end -md:order-1 -md:w-full" to="/timetable">РАСПИСАНИЕ</AtomButton>
        </div>
      </template>
    </SectionHero>
    <SectionDefault>
      <div class="mb-24 md:mb-48">
        <!-- Data is now provided via the mixin/page state -->
        <Accordion :trainings="accordionData" />
      </div>
      <Builder :blocks="blocks" />
    </SectionDefault>
  </main>
</template>

<script>
import AtomButton from '../../../components/atoms/AtomButton'
import AtomButtonDropdown from '../../../components/atoms/AtomButtonDropdown'
import Builder from '../../../components/builder/Builder'
import pageBuilder from '../../../components/mixins/pageBuilder.js'
import OrganismHero from '../../../components/organisms/layouts/OrganismHero'
import Accordion from '../../../components/templates/fitness/group-training/Accordion'
import SectionDefault from '../../../components/templates/layouts/SectionDefault'
import SectionHero from '../../../components/templates/layouts/SectionHero'

const mixinPageBuilder = pageBuilder({
  pageUrl: 'group-training',
  // Server-side fetch logic
  fetch: async ({ store, params, $axios, error }) => {
    const clubs = store.getters['modules/content/clubs']
    // If no slug in URL, we might want to redirect or pick first club
    const slug = params.club || (clubs.length ? clubs[0].slug : null)

    if (!slug) return

    try {
      const today = new Date()
      const dateFrom = today.toISOString().split('T')[0]
      const dateTo = new Date(today.getTime() + 13 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]

      const response = await $axios.get(`/api/fitbase/${slug}/classes?dateFrom=${dateFrom}&dateTo=${dateTo}&locale=ru`)

      // We store the result in the component's state via the mixin's mechanism
      // Assuming your mixin handles 'accordionData' or you can set it directly:
      return {
        accordionData: response.data || [],
      }
    } catch (e) {
      console.error('Fetch error:', e)
      return { accordionData: [] }
    }
  },
})

export default {
  name: 'FitnessGroup',
  components: {
    AtomButton,
    SectionDefault,
    Builder,
    SectionHero,
    OrganismHero,
    AtomButtonDropdown,
    Accordion,
  },
  mixins: [mixinPageBuilder],
  meta: {
    theme: 'dark',
  },
  // Ensure accordionData is initialized
  data() {
    return {
      accordionData: [],
      hero: {
        variant: 'dark-parallax',
        title1: 'Групповой',
        title2: 'тренинг',
        hideDesc: '-md:hidden',
        desc: 'В групповом тренинге представлены занятия в различных зонах клуба: тренажерный зал, студии групповых программ, баланса и пилатеса, зона боевых искусств, Сycle, а также бассейн.',
        image: 'studio/28.webp',
        imageWrap: 'img-border-0',
        imageMobile: 'studio/28-hero-mobile.webp',
        imagePosition: '!object-top',
        breadcrumbs: this.$breadcrumbs.groupTraining(),
      },
    }
  },
  computed: {
    clubs() {
      return this.$store.getters['modules/content/clubs']
    },
    clubDropdownItems() {
      return this.clubs.map(club => ({
        text: club.title,
        slug: club.slug,
      }))
    },
    // Find index based on the slug in the URL
    selectedClubIndex() {
      const slug = this.$route.params.club
      const index = this.clubs.findIndex(c => c.slug === slug)
      return index > -1 ? index : 0
    },
  },
  methods: {
    onClubSelect(index) {
      const club = this.clubs[index]
      if (club) {
        // Instead of fetching, we navigate.
        // Nuxt will trigger the fetch hook automatically on route change.
        this.$router.push(`/fitness/group-training/${club.slug}`)
      }
    },
  },
}
</script>
